import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
  en: {
    emailLabel: 'Email',
    invalidEmailValidation: 'Email address must be valid',
  },
})
